import styled from "styled-components";
import colors from "styles/colors";
import { fadeIn } from "styles/effects";
import Img from "components/commons/Img";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: fixed;
  z-index: 5000;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: hidden;
  animation: 1s ${fadeIn} forwards;
  box-sizing: border-box;
  background: rgba(0, 0, 0, 0.75);
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: top;
  width: 100%;
  height: 100%;
  max-width: 312px;
  max-height: 281px;
  padding: 24px;
  box-sizing: border-box;
  background: ${colors.gray100};
  border-radius: 8px;
  overflow: hidden;
  @media (max-width: 480px) {
    width: 100%;
  }
`;

export const Image = styled(Img)`
  width: 32px;
  height: 32px;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: right;
  min-height: 32px;
  width: 100%;
  max-width: 87px;
  box-sizing: border-box;
  margin: 28px 0 4px auto;
`;

export const Title = styled.div`
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
  width: 100%;
  box-sizing: border-box;
  font-family: "Domine";
  font-style: normal;
  font-weight: 400;
  font-size: 24px;
  line-height: 32px;
  color: ${colors.blue50};
  margin-top: 10px;
`;

export const Description = styled.div`
  display: flex;
  margin-top: 10px;
  font-family: "OpenSansRegular";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.1px;
  color: ${colors.gray20};
  @media (max-width: 980px) {
    font-size: 14px;
  }
`;
